import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { ShopOrderDetailComponent } from '../shop-order-detail/shop-order-detail.component';
import { OrderService, StoreResponseDto, OrdersListDto } from 'src/generated_client'
import { AuthService } from 'src/app/services/auth/auth.service';
import { MatTableDataSource } from '@angular/material/table';
import { SnackBarService } from 'src/app/services/snack-bar.service';

@Component({
  selector: 'app-rejected-with-card-shop-orders',
  templateUrl: './rejected-with-card-shop-orders.component.html',
  styleUrls: ['./rejected-with-card-shop-orders.component.css']
})

export class RejectedWithCardShopOrdersComponent implements OnInit {

  private currentStore: StoreResponseDto = {};
  orderList: OrdersListDto[] = [];
  dataSource = new MatTableDataSource();

  constructor(
    private dialog: MatDialog,
    private router: Router,
    private orderService: OrderService,
    private authService: AuthService,
    private snack: SnackBarService
  ) { }

  displayedColumns: string[] = ['id', 'comercio', 'usuario', 'direccion', 'items', 'opciones'];

  ngOnInit(): void {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    this.currentStore = this.authService.currentUserStore();

    this.orderService.apiOrderGetMpRejectedOrdersByStoreGet(this.currentStore.cdStore).subscribe(response => {
      this.orderList = response;
      this.dataSource.data = this.orderList;
    },
      err => {
        this.snack.openSnackBar(err.error.error, "Aceptar");
      })
  }


  openOrder(idOrder: number) {
    let order = this.orderList.find(x => x.cdOrder == idOrder);
    let items = order?.itemInOrderOutputDtos;
    this.dialog.open(ShopOrderDetailComponent, {
      data: {
        items: items,
        delivery: order?.qtDCharges,
        discount: order?.qtDiscount,
        discountItemValue: order?.qtItemsDiscountedTotal,
        total: order?.qtTotal,
        notes: order?.dsNotes
      }
    });
  }


}

